import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarRenameIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-rename"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                fill="#48505E"
                d="M24.25 7C24.6642 7 25 7.33579 25 7.75C25 8.16421 24.6642 8.5 24.25 8.5H23.5V23.5H24.25C24.6642 23.5 25 23.8358 25 24.25C25 24.6642 24.6642 25 24.25 25H21.25C20.8358 25 20.5 24.6642 20.5 24.25C20.5 23.8358 20.8358 23.5 21.25 23.5H22V8.5H21.25C20.8358 8.5 20.5 8.16421 20.5 7.75C20.5 7.33579 20.8358 7 21.25 7H24.25ZM18.25 9C18.6642 9 19 9.33579 19 9.75C19 10.1642 18.6642 10.5 18.25 10.5H8.75C8.61193 10.5 8.5 10.6119 8.5 10.75V21.25C8.5 21.3881 8.61193 21.5 8.75 21.5H18.25C18.6642 21.5 19 21.8358 19 22.25C19 22.6642 18.6642 23 18.25 23H8.75C7.7835 23 7 22.2165 7 21.25V10.75C7 9.7835 7.7835 9 8.75 9H18.25ZM14.1543 12.3086C14.4155 12.2182 14.7039 12.2329 14.9561 12.3535C15.2185 12.4791 15.3554 12.6991 15.416 12.8027C15.4842 12.9194 15.5532 13.0685 15.6162 13.2031L18.1797 18.6826C18.3548 19.0577 18.1924 19.5042 17.8174 19.6797C17.4423 19.8548 16.9958 19.6924 16.8203 19.3174L16.21 18.0117H12.79L12.1797 19.3174C12.0042 19.6924 11.5577 19.8548 11.1826 19.6797C10.8076 19.5042 10.6452 19.0577 10.8203 18.6826L13.3838 13.2031C13.4468 13.0685 13.5158 12.9194 13.584 12.8027C13.6446 12.6991 13.7815 12.4791 14.0439 12.3535L14.1543 12.3086ZM13.4922 16.5117H15.5078L14.5 14.3564L13.4922 16.5117Z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarRenameIcon);
export default Memo;
